import React from 'react';

const About = () => {
    return (
        <article className="space-y-4">
            <p>Product Engineer bei BELIMO und Informatikstudent an der OST, zuhause in Rapperswil und Silvaplana.</p>
        </article>
    );
};

export default About;